export default __webpack_public_path__ + "static/media/facebook.fad09735.png";